import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as subdepartment from '../subdepartment'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subdepartment.RESOURCE.payload.dimension.partialId,
      partialId: subdepartment.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Contains the files associated with this record in the shared knowledge base.',
    isOptional: true,
    name: 'Documents',
    partialId: PartialId.Standard.create('documents'),
    type: { isFile: true },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
